/* @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import EmailPreferencesList from 'bundles/account-settings/components/sections/email-preferences/EmailPreferencesList';
import { Sections } from 'bundles/account-settings/constants/SettingsConstants';
import type { CourseEmailPreference, UpdateStatus } from 'bundles/account-settings/types/EmailPreferences';

import _t from 'i18n!nls/account-settings';

type Props = {
  disabled: boolean;
  coursePreferences: CourseEmailPreference[];
  updateStatus: UpdateStatus;
};

const styles = {
  title: css`
    margin-block-end: var(--cds-spacing-100);
  `,
  supportText: css`
    margin-block-end: var(--cds-spacing-200);
  `,
};

const CourseEmailPreferences: React.FC<Props> = ({ disabled, coursePreferences, updateStatus }) => (
  <>
    <Typography2 component="h2" variant="subtitleMedium" css={styles.title}>
      {_t('Communication about courses you are enrolled in')}
    </Typography2>
    <Typography2 component="p" css={styles.supportText}>
      {_t(
        `Each course may send three types of emails. Announcements are sent from your course instructor,
        and may include special events, new materials, and learning or job resources exclusively offered to
        those enrolled in the course. Reminders are related to your course progress, such as deadline reminders.
        Discussion Forums notifies you of replies on one of your threads, likes/dislikes or any other
        communication directed towards you. You can choose whether or not you want to subscribe to each of these
        types of emails for each course.`
      )}
    </Typography2>
    <EmailPreferencesList
      disabled={disabled}
      type={Sections.COURSE_EMAIL_PREFERENCES}
      emailPreferences={coursePreferences}
      updateStatus={updateStatus}
    />
  </>
);

export default CourseEmailPreferences;
